<template>
  <div class="name-editor">
    <div
      v-if="!editMode && !client.first_name && !client.last_name"
      class="d-flex cursor-pointer"
      @click="startEditing"
    >
      <base-icon
        icon="plus"
        class="mr-2"
      /> <span class="base-input-text__placeholder">
        Add Name
      </span>
    </div>
    <base-text
      v-if="!editMode"
      semibold
      class="name-editor__text"
      :class="`${!readonly ? 'name-editor--clickable' : ''}`"
      @click="startEditing"
    >
      {{ client.first_name }} {{ client.last_name }}
    </base-text>

    <div
      v-if="editMode"
      class="d-flex align-items-center"
    >
      <input
        ref="input"
        v-model.trim="client.first_name"
        type="text"
        maxlength="25"
        class="w-100 mr-1"
        placeholder="First Name"
        @keypress.enter="stopEditing"
        @blur="onBlur"
        @focus="isFocused = true"
      >

      <input
        v-model.trim="client.last_name"
        type="text"
        maxlength="25"
        class="w-100 ml-1"
        placeholder="Last Name"
        @keypress.enter="stopEditing"
        @blur="onBlur"
        @focus="isFocused = true"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'NameEditor',
  props: {
    value: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFocused: false,
      editMode: false,
      client: null,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.client = { ...val }; // As we are using an object, we must create a clone.
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onBlur() {
      this.isFocused = false;

      setTimeout(() => {
        if (!this.isFocused) {
          this.stopEditing();
        }
      }, 100);
    },
    startEditing() {
      if (this.readonly) return;
      this.editMode = true;
      this.$nextTick().then(() => {
        this.$refs.input.focus();
      });
    },
    stopEditing() {
      this.editMode = false;
      this.$emit('input', this.client);
    },
  },
};
</script>

<style lang="scss" scoped>
.name-editor{
    margin: 0 auto;
    min-height: 28px;
    align-items: center;
    display: flex;
    max-width: 100%;

    &__text{
    }
    &--clickable {
      cursor: pointer;
    }
}
</style>
